import { render } from "./Universities.vue?vue&type=template&id=3345f889"
import script from "./Universities.vue?vue&type=script&lang=js"
export * from "./Universities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__